module.exports = __webpack_public_path__ + "static/media/symbol_archive.8b818c8f.svg";